import { FormEvent, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAlert } from 'react-alert'

import {
  CustomerModel,
  InterviewModel,
  ModelInterviewModel,
  SynthesisModel
} from '../../../domain/models'
import {
  fetchCustomer,
  fetchIntweview,
  fetchSynthesis,
  saveNewSynthesis,
  updateIntweview,
  updateSynthesis
} from '../../../main/usecases'

import { maskCpf } from '../../utils'
import {
  Button,
  EditorCard,
  ServicesHeader,
  PsychologicalQuestionInterview,
  SubHeader
} from '../../components'

import { IconSaveSvg, IconReturnSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'

const PsychologicalInterview = ({ match, setTab }: any) => {
  const [customer, setCustomer] = useState<CustomerModel>()
  const [interview, setInterview] = useState<InterviewModel>(
    {} as InterviewModel
  )
  console.log(match)
  const [synthesis, setSynthesis] = useState<SynthesisModel>(
    {} as SynthesisModel
  )
  const [answersToInterview, setAnswersToInterview] = useState({})
  const [synthesisData, setSynthesisData] = useState('')
  const alert = useAlert()

  const handleSaveNewPlaceholderInterview = async () => {
    const body = {
      ...(!synthesis.modeloAdm && {
        cdTextoSintese: synthesis?.cdTextoSintese
      }),
      tipoSintese: {
        cdTipoSintese: 1
      },
      texto: synthesisData
    }

    try {
      if (!synthesis.modeloAdm) {
        const response = await updateSynthesis({
          cdAvaliacao: match?.params?.idassessment
        }).update(body)
        alert.show('Salvo', {
          type: 'success',
          timeout: 4000
        })

        setSynthesis(response)
      } else {
        const response = await saveNewSynthesis({
          cdAvaliacao: match?.params?.idassessment
        }).post(body)
        alert.show('Salvo', {
          type: 'success',
          timeout: 4000
        })

        setSynthesis(response)
      }
    } catch (error) {
      console.error(error)
      alert.show('Erro ao Salvar', {
        type: 'error',
        timeout: 4000
      })
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const responseFetchSynthesis = await fetchSynthesis({
          cdAvaliacao: match?.params?.idassessment,
          type: 1
        }).load()

        setSynthesis(responseFetchSynthesis)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [match?.params?.idassessment])

  useEffect(() => {
    ;(async () => {
      try {
        const responseCustomer = await fetchCustomer({
          id: match?.params?.id
        }).load()
        const responseInterview = await fetchIntweview({
          id: match?.params?.idassessment,
          flag: match?.params?.flag === 'true'
        }).load()
        setCustomer(responseCustomer)
        setInterview(responseInterview)
        setSynthesisData(interview?.sintese)
      } catch (error) {
        console.error(error)
      }
    })()
  }, [
    match?.params?.id,
    match?.params?.idassessment,
    interview?.sintese,
    match?.params?.flag
  ])

  const onSubmit = async (event: FormEvent) => {
    event.preventDefault()

    const body = {
      cdEntrevista: interview?.cdEntrevista,
      sintese: synthesisData,
      modeloEntrevista: Object.values(answersToInterview)
    }

    try {
      await updateIntweview({
        id: match?.params?.idassessment
      }).update(body)
      alert.show('Salvo', {
        type: 'success',
        timeout: 4000
      })
      if (setTab) {
        setTab(1)
      }
      // goToUrl(history, `/meus-pacientes/${match?.params?.id}/prontuario`)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <S.Wrapper>
      {customer && (
        <SubHeader
          name={customer.nome}
          cpf={maskCpf(customer.cpf)}
          page="Voltar"
          link={`/meus-pacientes/${match?.params?.id}/prontuario?serviceId=${match.params.idservico}`}
        />
      )}
      <S.CardContainer>
        <ServicesHeader onClick={onSubmit} title="Entrevista" />
        <S.CardContent>
          <EditorCard
            data={synthesisData}
            setData={setSynthesisData}
            title="Síntese da entrevista"
            hasHelp
            onInputPlaceholder={() => setSynthesisData(synthesis.texto || '')}
            handleSaveNewPlaceholder={handleSaveNewPlaceholderInterview}
            placeholder={synthesis.texto}
            tooltipText="Insira aqui a síntese do paciente. Este texto poderá ser utilizado na construção dos documentos psicológicos."
          />
          <PsychologicalQuestionInterview
            modelInterview={interview?.modeloEntrevista}
            handleAnwers={(answers: ModelInterviewModel) =>
              setAnswersToInterview(answers)
            }
          />
          <S.ButtonsContainer>
            <Button
              initialIcon={<IconSaveSvg />}
              className="button-save"
              onClick={onSubmit}
            >
              Salvar
            </Button>
            <Button
              initialIcon={<IconReturnSvg />}
              hasSecodaryButton
              className="button-return-to-list"
            >
              <Link
                to={`/meus-pacientes/${match?.params?.id}/prontuario?serviceId=${match.params.idservico}`}
              >
                Retornar à listagem
              </Link>
            </Button>
          </S.ButtonsContainer>
        </S.CardContent>
      </S.CardContainer>
    </S.Wrapper>
  )
}
export default PsychologicalInterview
